import type * as React from "react";

import { cx } from "../../lib/cx";
import s from "./StatRow.module.css";

export interface StatRowProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  value: string | number;
  /** Participación sobre el total, 0 a 100. */
  share: number;
  /** Color de la barra: un token (`var(--channel-cartel)`). Por default, el violeta de acción. */
  color?: string;
}

/** Una cifra con su barra de participación: para el origen de las consultas y los pasos del recorrido. */
export function StatRow({ label, value, share, color = "var(--action-primary)", className, style, ...rest }: StatRowProps) {
  const ancho = Math.max(0, Math.min(100, share));
  return (
    <div
      className={cx(s.fila, className)}
      style={{ ...style, "--_share": `${ancho}%`, "--_color": color } as React.CSSProperties}
      {...rest}
    >
      <span className={s.etiqueta}>{label}</span>
      <span className={s.valor}>{value}</span>
      <span className={s.pista} aria-hidden="true">
        <span className={s.barra} />
      </span>
    </div>
  );
}
